export default __webpack_public_path__ + "static/icomoon-9acbb0fe41825f21dbbf47e505c78504.svg";